export function downloadFileFromUrl({
  url,
  name,
  type,
}: {
  url: string;
  name: string;
  type: string;
}) {
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = name;
  anchor.type = type;

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
